import { render } from "./ChartView.vue?vue&type=template&id=8bd54ac2&ts=true"
import script from "./ChartView.vue?vue&type=script&lang=ts"
export * from "./ChartView.vue?vue&type=script&lang=ts"

import "./ChartView.vue?vue&type=style&index=0&id=8bd54ac2&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__